import { Flex, Heading, Button, Stack } from '@chakra-ui/react'
import { BsCardChecklist, BsBuilding } from "react-icons/bs";
import { HashLink } from 'react-router-hash-link'
import LoginForm from '../components/login/LoginForm';
import { Link as ReactLink } from 'react-router-dom'

const AppTitle = () => {
    const shadow = { textShadow: '2px 2px 4px #000000' }
    return (
        <Flex align="center" w="full" direction="column" color="white">
            <Heading size="2xl" style={shadow} textAlign="center">ระบบบริหารสวัสดิการบ้านพัก</Heading>
            <Heading size="xl" mt={4} style={shadow}  textAlign="center">ข้าราชการศาลยุติธรรม (กรุงเทพฯ)</Heading>
        </Flex>
    )
}

const MenuButton = ({ ...rest }) => {
    return (
        <Stack {...rest} spacing={{base:2,md:10}} direction={{base:"column",md:"row"}} w="80%" justify="center">
            <ReactLink to="/queue" >
                <Button w={{base:"full", md:"fit-content"}} leftIcon={<BsCardChecklist />} colorScheme="orange" >ตรวจสอบลำดับคิวฯ</Button>
            </ReactLink>
            <HashLink smooth to={'/#building_info'} >
                <Button w={{base:"full", md:"fit-content"}} leftIcon={<BsBuilding />} colorScheme="blue" >ข้อมูลอาคารที่พัก</Button>
            </HashLink>
        </Stack>
    )
}

const Login = () => {
    return (
        <Flex w="full" minH="100vh" bgImage="bg.jpg" bgSize="cover" justify="center" align="center" direction="column" p={4}>
            <Flex ml={{ lg: "350px" }} mt="100px" direction="column" align="center">
                <AppTitle />
                <LoginForm mt={6} />
                <MenuButton mt={5} />
            </Flex>
        </Flex>
    )
}

export default Login
